import { Box, Button, Container, Stack } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SidebarType } from '../../../lib/types/types';
import OrganisationData from './content/organisation-data/OrganisationData';
// import NutzerVerwaltung from './content/nutzerverwaltung/NutzerVerwaltung';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Contents from '../../../components/ui-component/mein-bereich/Contents';
import SideBars from '../../../components/ui-component/mein-bereich/Sidebars';
import { PAGES_URLS } from '../../../lib/constants/routes';
import OrganisationDocuments from './content/documents/OrganisationDocuments';
import { useLocation } from 'react-router-dom';
// import MailBenachrichtigun from './content/mail-benachrichtigung/MailBenachrichtigun';

function MeineOrganisation() {
	const navigate = useNavigate();
	const location = useLocation();
    const params = new URLSearchParams(location.search);
    const initialTab = Number(params.get('tab')) || 0;
	const [activesideBar, setActiveSideBar] = useState<number>(initialTab);
	const sidebars: SidebarType = [
		{ label: 'Meine Organisation', element: <OrganisationData /> },
		{ label: 'Dokumente', element: <OrganisationDocuments /> },
		// { label: 'Bankdaten', element: <BankData /> },
		// { label: 'Mailbenachrichtungen', element: <MailBenachrichtigun /> },
	];
	const toggleSideBarButton = (_event: React.SyntheticEvent, newSideBarButton: number) => {
		setActiveSideBar(newSideBarButton);
	};

	return (
		<Container>
			<Stack direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'center', md: 'flex-start' }}>
				<Box>
					<Button
						variant='outlined'
						startIcon={<ArrowBackIcon />}
						onClick={() => {
							navigate(PAGES_URLS.MeinBereich);
						}}
						sx={{ m: '1rem 2rem 1rem 0', minWidth: '16.4rem' }}
					>
						Zurück zu Mein Bereich
					</Button>
					<SideBars sidebars={sidebars} activeSideBarButton={activesideBar} toggleSideBarButton={toggleSideBarButton} />
				</Box>

				<Contents sidebars={sidebars} activeSideBarButton={activesideBar} />
			</Stack>
		</Container>
	);
}

export default MeineOrganisation;
